import { setLatlng, setSerachedLocation } from "../../../ReduxTool/Slice/Consumer/ConsumerReducers";
import { setInformationModal, setMarkerState, setShowInfoModal, toggleRoofConfirmBtn } from "../../../ReduxTool/Slice/Map/MapReducer";
import { setLocationPinLatLng } from "../../../ReduxTool/Slice/Marker/MarkersReducer";
import { AppDispatch } from "../../../ReduxTool/store/store";
import { IUpdateEvent } from "../../../Utils/Const";
import globalLayers from "../../../Utils/CustomerMaps/Maps/GlobaLMap";
import { fetchCompleteAddress } from "../../../Utils/CustomerMaps/Maps/LazyloadMap";
import { markerSymbol } from "../../../Utils/CustomerMaps/MarkerSymbols/MarkerSymbols";
import { changeLocationMarker } from "../../Customer/MarkersFunctions/changeLocationMarker";

export const SearchViewModal = (dispatch: AppDispatch, handlePosition: (event: MouseEvent) => void) => {

    globalLayers.sketchViewModel?.on("update", function (event: IUpdateEvent) {
        // Cancelling a sketch can emit an update event without a marker graphic.
        const markerGraphic = event.graphics?.[0];
        const markerPoint = markerGraphic?.geometry;
        if (!markerPoint) return;
        
        if (event.state === "start") {
            dispatch(toggleRoofConfirmBtn(true));
            // dispatch(setToolTipModal({ state: true, title: "Great Job!", content: "Now, drag it to your preferred location." }))
            dispatch(setInformationModal({state:true,title:"Great Job!",content:"Now, drag it to your preferred location."}))
            dispatch(setLatlng({ lat: markerPoint.latitude, lng: markerPoint.longitude }));
            dispatch(setLocationPinLatLng({ lat: markerPoint.latitude, lng: markerPoint.longitude }));
            // getAddressFromPinDropCoordinates(event.graphics[0].geometry.longitude, event.graphics[0].geometry.latitude).then(
            //     (searchAddress: any) => {
            //         // console.log('searchAddressdrag', searchAddress)
            //         dispatch(setSerachedLocation(searchAddress))
            //     }
            // );
            
            fetchCompleteAddress(markerPoint.latitude, markerPoint.longitude,true).then((searchAddress:any) => {
                setTimeout(()=>{
                    const inp = globalLayers.searchWidgetInput;
                    if (inp && inp.container.querySelector(".esri-search__input") && searchAddress) {
                        inp.container.querySelector(".esri-search__input").value =searchAddress;
                    }
                },2000);
                
                dispatch(setSerachedLocation(searchAddress));
            });
        }
        if (event.toolEventInfo) {
            changeLocationMarker(event, markerSymbol)
            if (event.toolEventInfo.type === "move") {
                if (globalLayers.markerState !== 'move') {
                    globalLayers.markerState = 'active';
                    dispatch(setMarkerState('locate'))
                    dispatch(setShowInfoModal(true))
                }
            }
            // 
            if (event.toolEventInfo.type === "move-stop") {
                dispatch(setMarkerState('confirm'));
                globalLayers.latitude = markerPoint.latitude;
                globalLayers.longitude = markerPoint.longitude;
                globalLayers.RemoveLayer('GeoJson');
                globalLayers.showRoofSelectionBtn = true;
                dispatch(toggleRoofConfirmBtn(true));
                dispatch(setLatlng({ lat: markerPoint.latitude, lng: markerPoint.longitude }));
                dispatch(setLocationPinLatLng({ lat: markerPoint.latitude, lng: markerPoint.longitude }));
                // getAddressFromPinDropCoordinates(event.graphics[0].geometry.longitude, event.graphics[0].geometry.latitude).then(
                //     (searchAddress: any) => {
                //         // console.log('searchAddressdrag', searchAddress)
                //         dispatch(setSerachedLocation(searchAddress))
                //     }
                // );
                
                fetchCompleteAddress(markerPoint.latitude, markerPoint.longitude,true).then((searchAddress:any) => {
                    setTimeout(()=>{
                        const inp = globalLayers.searchWidgetInput;
                        if (inp && inp.container.querySelector(".esri-search__input") && searchAddress) {
                            inp.container.querySelector(".esri-search__input").value =searchAddress;
                        }
                    },2000);
                    
                    dispatch(setSerachedLocation(searchAddress));
                });
                document.removeEventListener('click', (e) => handlePosition(e));
            }
        }
    });
}
